import React from "react";
import { Modal, Row, Col, Table, Badge } from "react-bootstrap";

const ViewWishlistModal = ({ show, handleClose, IMG_URL, onImageClick }) => {
  const item = show;
  const user = item?.User;
  const product = item?.Product;
  const variants = product?.Product_Variants || [];
  const productImages = product?.Product_Images || [];

  const getImageUrl = (image) => {
    if (!image) return "";
    return image.startsWith("http") ? image : IMG_URL + image;
  };

  if (!item) return null;

  return (
    <Modal show={!!item} onHide={handleClose} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Wishlist Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <h5 className="mb-3">User Details</h5>
        <Row className="mb-4">
          <Col md={4} className="mb-2">
            <strong>Name:</strong>{" "}
            {[user?.name, user?.last_name].filter(Boolean).join(" ") || "N/A"}
          </Col>
          <Col md={4} className="mb-2">
            <strong>Email:</strong> {user?.email || "N/A"}
          </Col>
          <Col md={4} className="mb-2">
            <strong>Contact No.:</strong> {user?.contact_no || "N/A"}
          </Col>
          <Col md={4} className="mb-2">
            <strong>User ID:</strong> {user?.id ?? item?.user_id ?? "N/A"}
          </Col>
          <Col md={4} className="mb-2">
            <strong>User Status:</strong>{" "}
            <Badge bg={user?.status ? "success" : "secondary"}>
              {user?.status ? "Active" : "Inactive"}
            </Badge>
          </Col>
        </Row>

        <hr />
        <h5 className="mb-3">Wishlist Details</h5>
        <Row className="mb-4">
          <Col md={4} className="mb-2">
            <strong>Wishlist ID:</strong> {item?.id}
          </Col>
          <Col md={4} className="mb-2">
            <strong>Created At:</strong>{" "}
            {item?.createdAt
              ? new Date(item.createdAt).toLocaleString()
              : "N/A"}
          </Col>
          <Col md={4} className="mb-2">
            <strong>Status:</strong>{" "}
            <Badge bg={item?.status ? "success" : "secondary"}>
              {item?.status ? "Active" : "Inactive"}
            </Badge>
          </Col>
        </Row>

        <hr />
        <h5 className="mb-3">Product Details</h5>
        <Row className="mb-3">
          <Col md={3} className="mb-3">
            {product?.image ? (
              <img
                src={getImageUrl(product.image)}
                alt={product?.name || "Product"}
                onClick={() => onImageClick?.(getImageUrl(product.image))}
                style={{
                  width: "100%",
                  maxWidth: "180px",
                  height: "180px",
                  objectFit: "contain",
                  cursor: "pointer",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  padding: "5px",
                }}
              />
            ) : (
              <div>No Product Image</div>
            )}
            <small className="text-muted d-block mt-1">
              Click image to preview
            </small>
          </Col>

          <Col md={9}>
            <p>
              <strong>Product Name:</strong> {product?.name || "N/A"}
            </p>
            <p>
              <strong>Product ID:</strong>{" "}
              {product?.id ?? item?.product_id ?? "N/A"}
            </p>
            <p>
              <strong>Item Code:</strong> {product?.item_code || "N/A"}
            </p>
            <p>
              <strong>Price:</strong>{" "}
              {(product?.Product_Variants?.[0]?.price ?? product?.price) != null
                ? `₹${product?.Product_Variants?.[0]?.price ?? product?.price}`
                : "N/A"}
            </p>

            <p>
              <strong>MRP:</strong>{" "}
              {(product?.Product_Variants?.[0]?.mrp ?? product?.mrp) != null
                ? `₹${product?.Product_Variants?.[0]?.mrp ?? product?.mrp}`
                : "N/A"}
            </p>
            <p>
              <strong>Product Status:</strong>{" "}
              <Badge bg={product?.status ? "success" : "secondary"}>
                {product?.status ? "Active" : "Inactive"}
              </Badge>
            </p>
          </Col>
        </Row>

        {productImages.length > 0 && (
          <>
            <h6 className="mt-3">Product Images</h6>
            <Row className="g-3 mb-4">
              {productImages.map((image) => (
                <Col xs={6} md={3} key={image.id}>
                  <img
                    src={getImageUrl(image.image)}
                    alt="Product"
                    onClick={() => onImageClick?.(getImageUrl(image.image))}
                    style={{
                      width: "100%",
                      height: "140px",
                      objectFit: "contain",
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "4px",
                    }}
                  />
                </Col>
              ))}
            </Row>
          </>
        )}

        <h6 className="mt-3">Product Variants</h6>

        {variants.length > 0 ? (
          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>Variant ID</th>
                <th>Variant Name / Option</th>
                <th>Price</th>
                <th>MRP</th>
                <th>Stock</th>
                {/* <th>Subscription Stock</th> */}
              </tr>
            </thead>

            <tbody>
              {variants.map((variant) => {
                const variantStocks = variant.Product_Variant_Stocks || [];

                return (
                  <React.Fragment key={variant.id}>
                    <tr>
                      <td>{variant.id}</td>
                      <td>{variant.name || variant.Metal?.name || "N/A"}</td>
                      <td>
                        {variant.price != null ? `₹${variant.price}` : "N/A"}
                      </td>
                      <td>{variant.mrp != null ? `₹${variant.mrp}` : "N/A"}</td>
                      <td>{variant.general_stock ?? "N/A"}</td>
                      {/* <td>
                        {variantStocks.length > 0
                          ? variantStocks
                              .map((stock) => stock.subscription_stock ?? "N/A")
                              .join(", ")
                          : "N/A"}
                      </td> */}
                    </tr>

                    {variantStocks.flatMap((variantStock) =>
                      (variantStock.Double_Variant_Stocks || []).map(
                        (doubleStock) => {
                          const doubleVariant = doubleStock.Double_Variant;

                          return (
                            <React.Fragment key={`double-${doubleStock.id}`}>
                              <tr>
                                <td>{doubleVariant?.id ?? "N/A"}</td>
                                <td>
                                  └{" "}
                                  {doubleVariant?.name ||
                                    doubleVariant?.Size?.name ||
                                    "Double variant"}
                                </td>
                                <td>
                                  {doubleVariant?.price != null
                                    ? `₹${doubleVariant.price}`
                                    : "N/A"}
                                </td>
                                <td>
                                  {doubleVariant?.mrp != null
                                    ? `₹${doubleVariant.mrp}`
                                    : "N/A"}
                                </td>
                                <td>{doubleStock.stock ?? "N/A"}</td>
                                <td>N/A</td>
                              </tr>

                              {(doubleStock.Triple_Variant_Stocks || []).map(
                                (tripleStock) => {
                                  const tripleVariant =
                                    tripleStock.Triple_Variant;

                                  return (
                                    <tr key={`triple-${tripleStock.id}`}>
                                      <td>{tripleVariant?.id ?? "N/A"}</td>
                                      <td>
                                        &nbsp;&nbsp;&nbsp;└{" "}
                                        {tripleVariant?.name ||
                                          tripleVariant?.Diamond?.name ||
                                          "Triple variant"}
                                      </td>
                                      <td>
                                        {tripleVariant?.price != null
                                          ? `₹${tripleVariant.price}`
                                          : "N/A"}
                                      </td>
                                      <td>
                                        {tripleVariant?.mrp != null
                                          ? `₹${tripleVariant.mrp}`
                                          : "N/A"}
                                      </td>
                                      <td>{tripleStock.stock ?? "N/A"}</td>
                                      <td>N/A</td>
                                    </tr>
                                  );
                                },
                              )}
                            </React.Fragment>
                          );
                        },
                      ),
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <p className="text-muted">No variants available.</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewWishlistModal;
